import { Enums, Interfaces } from '@configur-tech/upit-core-types';

const InitialCMS: Interfaces.Connection = {
  name: '',
  status: Enums.ConnectionStatus.ACTIVE,

  access: {
    manage: {
      organisation: [],
      team: [],
      user: [],
    },
    edit: { organisation: [], team: [], user: [] },
    view: { organisation: [], team: [], user: [] },
  },

  configuration: {
    groups: [],
  },
};

export default InitialCMS;
